
export enum ColorNames {
  primary = 'primary',
  success = 'success',
  accent = 'accent',
  warn = 'warn',
  dark = 'dark'
}
